import { Link } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import copy from 'copy-to-clipboard';

import {
	useAuthAlerts,
	useLatestScanId,
} from '../../store/scanSession/selectors';
import AlertIllustration from '../../images/alert.svg';

function Counterfeit({ Buttons, Content, ...props }) {
	const { t } = useTranslation();
	const theme = useTheme();
	const alerts = useAuthAlerts();
	const latestScanId = useLatestScanId();

	return (
		<>
			<Content>
				<Grid
					item
					xs={12}
					style={{
						display: 'flex',
						justifyContent: 'center',
						marginTop: theme.spacing(3),
						marginBottom: theme.spacing(-1),
					}}
				>
					<img
						src={AlertIllustration}
						alt={`${t('verification_counterfeit.img_alt')}`}
					/>
				</Grid>
				<Grid item xs={12}>
					<Typography
						variant="h4"
						component="h2"
						style={{ textAlign: 'center', color: theme.palette.error.main }}
					>
						{t('verification_counterfeit.title')}
					</Typography>
				</Grid>

				{latestScanId && (
					<Chip
						size="small"
						style={{
							background: theme.palette.error.main,
							color: theme.palette.common.white,
							margin: 'auto',
							cursor: 'pointer',
						}}
						onClick={() => copy(latestScanId)}
						label={
							<Typography variant="caption">
								{t('verification_counterfeit.scan_id')} {latestScanId}
							</Typography>
						}
					/>
				)}

				{!!alerts.length && (
					<Grid item xs={12}>
						<Paper elevation={1}>
							<div style={{ padding: theme.spacing('1px', 3) }}>
								{alerts.map((status) => (
									<div style={{ margin: theme.spacing(2, 0) }} key={status}>
										<Typography variant="subtitle1">
											{t(`verification_counterfeit.alerts.${status}`)}
										</Typography>
										<Typography variant="body1">
											{t(`verification_counterfeit.alerts.${status}_text`)}
										</Typography>
									</div>
								))}
							</div>
						</Paper>
					</Grid>
				)}
				<Grid item xs={12}>
					<Divider />
				</Grid>
				<Grid item xs={12}>
					<Typography variant="body1" gutterBottom={true}>
						{t('verification_counterfeit.description_line1')}
					</Typography>
					<Typography variant="body1" gutterBottom={true}>
						{t('verification_counterfeit.description_line2')}
					</Typography>
					<Typography variant="body1" gutterBottom={true}>
						{t('verification_counterfeit.description_line3')}
					</Typography>
				</Grid>
			</Content>

			<Buttons>
				<Grid item xs={12}>
					<Button
						component={Link}
						to="/step1"
						variant="contained"
						color="primary"
						fullWidth={true}
						disableElevation={true}
					>
						{t('verification_counterfeit.scan_next')}
					</Button>
				</Grid>
				<Grid item xs={12}>
					<Button
						href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL_ADDRESS}${
							latestScanId ? `?subject=Scan id ${latestScanId}` : ''
						}`}
						target="_blank"
						variant="outlined"
						color="default"
						fullWidth={true}
						disableElevation={true}
					>
						{t('verification_counterfeit.contact_us')}
					</Button>
				</Grid>
			</Buttons>
		</>
	);
}

export default Counterfeit;
